import { GroupBase, StylesConfig } from 'react-select';

const ReactSelectBootstrapStyle: StylesConfig<any, boolean, GroupBase<any>> = {
    control: (provided, state)=> {
        const base = { ...provided, borderRadius: "0.25rem", borderWidth: "1px" };
        if(state.isFocused )
            return {
                ...base,
                borderColor: "var(--feature-secondary)",
                boxShadow: "0 0 0 0.25rem rgba(251, 128, 17, 0.25)"
            };
        return base;
    },
};

export { ReactSelectBootstrapStyle };
